import { useEffect } from 'react';
import { Heading } from '@frontend/design-system';
import { useCollectPaymentMultiContext } from '../../../collect-payment-multi.context';
import { RegisterTerminalNavigationSwitch } from './register-terminal-navigation-switch';
import { RegisterTerminalStepBodyProps } from './register-terminal.types';

export const RegisterTerminalJustifi = () => {
  return <RegisterTerminalNavigationSwitch body={RegisterTerminalJustifiBody} />;
};

const RegisterTerminalJustifiBody = (_props: RegisterTerminalStepBodyProps) => {
  const { setMinWidth, resetMinWidth } = useCollectPaymentMultiContext();

  // const { activeLocationId, paymentsUrl } = useCollectPaymentMultiContext();

  // const multiStepControl = useMultiStepControl({
  //   onComplete: () => {
  //     onComplete();
  //   },
  //   onCancel: () => {
  //     onCancel();
  //   },
  // });

  // const childGoBack = useCallback(() => {
  //   multiStepControl.goPrevStep();
  // }, [multiStepControl.goPrevStep]);

  // const goToChildStep = useCallback(
  //   (step: RegisterTerminalModalSteps) => {
  //     multiStepControl.goToStep({ orStep: step });
  //   },
  //   [multiStepControl.goToStep]
  // );

  useEffect(() => {
    setMinWidth(776);

    return () => {
      resetMinWidth();
    };
  }, []);

  return (
    <div>
      <Heading>Justifi Terminals are not supported</Heading>
    </div>
  );
};
